import { createFileRoute } from "@tanstack/react-router";
import { ConnectAzure } from "../../../features/infrastructure/cloud-connect";

export const Route = createFileRoute("/_authed/$org/infrastructure/cloudaccounts/new/azure")({ component: Page });

function Page() {
  const { org } = Route.useParams();
  return <ConnectAzure org={org} />;
}
